export default [
    {
        path: "index",
        component: "index",
        meta: {
            title: "首页",
            bottomNav: true
        }
    },
    {
        path: "search",
        component: "search",
        meta: {
            title: "查询",
            bottomNav: true
        }
    },
    {
        path: "category",
        component: 'category',
        meta: {
            title: "分类",
            bottomNav: true
        },
        children: [{
            path: "category/product",
            component: 'category/product',
            meta: {
                title: "商品列表"
            }
        }, {
            path: "category/product/tags",
            component: 'category/product/tags',
            meta: {
                title: "热销商品"
            }
        }, {
            path: "category/buy",
            component: 'category/buy',
            meta: {
                title: "商品详情",
                hidden: true
            }
        }]
    }, {
        path: "article",
        component: 'article',
        redirect: "article/index",
        meta: {
            title: "动态",
            bottomNav: false
        },
        children: [{
            path: "article/index",
            component: 'article/index',
            meta: {
                title: "动态列表"
            }
        }, {
            path: "article/details",
            component: 'article/details',
            meta: {
                title: "动态详情",
            }
        }]
    }, {
        path: "news",
        name: "news",
        component: 'news',
        redirect: "news/index",
        meta: {
            title: "通知中心",
            bottomNav: true
        },
        children: [{
            path: "news/index",
            component: 'news/index',
            meta: {
                title: "通知总览"
            }
        }, {
            path: "news/goodsprice",
            component: 'news/goodsprice',
            meta: {
                title: "调价通知",
            }
        }]
    },
    {
        path: "cart",
        component: "cart",
        redirect: "cart/index",
        meta: {
            title: "购物车",
            bottomNav: true
        },
        children: [{
            path: "cart/index",
            component: 'cart/index',
            meta: {
                title: "购物车列表",
            }
        }, {
            path: "cart/order",
            component: 'cart/order',
            meta: {
                title: "订单结算",
                hidden: true
            }
        }, {
            path: "cart/buy",
            component: 'cart/buy',
            meta: {
                title: "订单付款",
                hidden: true,
            }
        }, {
            path: "cart/buynew",
            component: 'cart/buy2',
            meta: {
                title: "订单付款",
                hidden: true,
            }
        }]
    },
    {
        path: "user",
        component: 'user',
        redirect: "user/index",
        meta: {
            title: "会员中心",
            bottomNav: true
        },
        children: [
            {
                path: "user/index",
                meta: {
                    title: "会员中心",
                }
            },
            {
                path: "user/login",
                meta: {
                    title: "会员登录",
                    hidden: true
                }
            },
            {
                path: "user/findpwd",
                meta: {
                    title: "找回密码",
                    hidden: true
                }
            },
            {
                path: "user/wallettc",
                meta: {
                    title: "我的佣金",
                    hidden: true
                }
            },
            {
                path: "user/tixian",
                meta: {
                    title: "佣金提现",
                    hidden: true
                }
            },
            {
                path: "user/register",
                meta: {
                    title: "会员注册",
                    hidden: true
                }
            },
            {
                path: "user/acceptNotice",
                meta: {
                    title: "收货地址",
                }
            },
            {
                path: "user/usersafe",
                meta: {
                    title: "安全中心",
                }
            },
            {
                path: "user/addressdeit",
                meta: {
                    title: "地址编辑",
                }
            },
            {
                path: "user/addresslist",
                meta: {
                    title: "地址管理",
                }
            },
            {
                path: "user/personal",
                meta: {
                    title: "个人资料",
                }
            },
            {
                path: "user/signin",
                meta: {
                    title: "签到中心",
                }
            },
            {
                path: "user/wallet",
                meta: {
                    title: "余额充值",
                }
            },
            {
                path: "user/upgradeing",
                meta: {
                    title: "会员升级",
                }
            },
            {
                path: "user/walletmy",
                meta: {
                    title: "我的钱包",
                    hidden: true
                }
            },
            {
                path: "user/tipset",
                meta: {
                    title: "通知管理",
                    hidden: true
                }
            },
            {
                path: "user/notify",
                meta: {
                    title: "消息通知",
                }
            },
            {
                path: "user/loglogin",
                meta: {
                    title: "登陆日志",
                }
            },
            {
                path: "user/openapi",
                meta: {
                    title: "对接密钥",
                }
            },
            {
                path: "user/kefu",
                meta: {
                    title: "在线客服",
                }
            },
            {
                path: "user/order",
                redirect: "user/order/index",
                meta: {
                    title: "订单管理",
                },
                children: [{
                    path: "user/order/index",
                    meta: {
                        title: "我的订单",
                        hidden: true
                    }
                }, {
                    path: "user/order/express",
                    meta: {
                        title: "快递信息",
                    }
                }, {
                    path: "user/order/desc",
                    meta: {
                        title: "订单详情",
                        hidden: true
                    }
                }]
            },
            {
                path: "user/receipt",
                redirect: "user/receipt/index",
                meta: {
                    title: "发票管理",
                },
                children: [{
                    path: "user/receipt/index",
                    meta: {
                        title: "发票列表",
                        hidden: true
                    }
                }, {
                    path: "user/receipt/title",
                    meta: {
                        title: "发票抬头管理",
                        hidden: true
                    }
                }, {
                    path: "user/receipt/detail",
                    meta: {
                        title: "发票详情",
                        hidden: true
                    }
                }]
            },
            {
                path: "user/substation",
                redirect: "user/substation/index",
                meta: {
                    title: "分销管理",
                },
                children: [{
                    path: "user/substation/index",
                    meta: {
                        title: "管理后台",
                        hidden: true
                    }
                }, {
                    path: "user/substation/welcome",
                    meta: {
                        title: "开通分销",
                        hidden: true
                    }
                }, {
                    path: "user/substation/page",
                    meta: {
                        title: "分销介绍",
                    }
                }, {
                    path: "user/substation/order",
                    meta: {
                        title: "分销订单",
                        hidden: true
                    }
                }, {
                    path: "user/substation/userlist",
                    meta: {
                        title: "用户管理",
                        hidden: true
                    }
                }, {
                    path: "user/substation/sitelist",
                    meta: {
                        title: "子站管理",
                        hidden: true
                    }
                }, {
                    path: "user/substation/setting",
                    meta: {
                        title: "网站设置",
                        hidden: true
                    }
                }, {
                    path: "user/substation/log_money",
                    meta: {
                        title: "账户明细",
                        hidden: true
                    }
                }, {
                    path: "user/substation/log_operation",
                    meta: {
                        title: "操作日志",
                        hidden: true
                    }
                }, {
                    path: "user/substation/tixian",
                    meta: {
                        title: "佣金提现",
                        hidden: true
                    }
                }, {
                    path: "user/substation/price",
                    meta: {
                        title: "商品管理",
                        hidden: true
                    }
                }, {
                    path: "user/substation/succpage",
                    meta: {
                        title: "开通成功",
                        hidden: true
                    }
                }]
            },
            {
                path: "user/service",
                meta: {
                    title: "订单售后"
                }
            },
            {
                path: "user/record",
                meta: {
                    title: "余额明细"
                }
            },
            {
                path: "user/coupons",
                meta: {
                    title: "我的优惠券"
                }
            },
            {
                path: "user/like",
                meta: {
                    title: "我的收藏"
                }
            },
            {
                path: "user/history",
                meta: {
                    title: "浏览历史"
                }
            },
            {
                path: "user/integral",
                meta: {
                    title: "积分明细"
                }
            },
            {
                path: "user/kefupage",
                meta: {
                    title: "在线客服"
                }
            },
        ]
    }
];


// WEBPACK FOOTER //
// ./src/router/modules/root.js